export default {
    en: {
        title: 'Privacy Policy for the “PromptReveal for WeryAI” Browser Extension',
        section1: {
            title: '1. Data We Collect',
            content1:
                'Image Data: When you use the “Reverse Prompt” feature, the image you right-click on is temporarily uploaded to our secure server solely for the purpose of generating a descriptive text prompt. We do not permanently store these images on our servers.',
            content2:
                'Technical & Usage Data: We may collect anonymous information such as your browser version, extension version, and basic usage events (e.g., feature used) to help us diagnose problems and improve the extension. This data is not linked to your identity.',
        },
        section2: {
            title: '2. How We Use Your Data',
            content1:
                'To provide the core functionality of analyzing images and returning AI-generated prompts.',
            content2: 'To improve the accuracy and performance of our AI models.',
            content3: 'For necessary troubleshooting and security purposes.',
        },
        section3: {
            title: '3. Data Sharing',
            content1:
                'We do not sell your personal data or image content. We may share anonymized, aggregated data with third-party services (e.g., AWS) that help us operate the extension. These partners are bound by strict data protection agreements.',
        },
        section4: {
            title: '4. Your Rights',
            content1:
                'Depending on your location, you may have rights to access, correct, or delete your personal data. To exercise these rights, contact us at: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Changes',
            content1:
                'We may update this policy. Continued use of the extension after changes constitutes acceptance.',
        },
    },
    zh: {
        title: '“PromptReveal for WeryAI”浏览器扩展隐私政策',
        section1: {
            title: '1. 我们收集的数据',
            content1:
                '图像数据：当您使用“反向提示词”功能时，您右键单击的图像会暂时上传到我们的安全服务器，仅用于生成描述性文本提示。我们不会在服务器上永久存储这些图像。',
            content2:
                '技术和使用数据：我们可能会收集匿名信息，例如您的浏览器版本、扩展版本和基本使用事件（例如使用的功能），以帮助我们诊断问题并改进扩展。此数据与您的身份无关。',
        },
        section2: {
            title: '2. 我们如何使用您的数据',
            content1: '提供分析图像和返回 AI 生成的提示的核心功能。',
            content2: '提高我们 AI 模型的准确性和性能。',
            content3: '用于必要的故障排除和安全目的。',
        },
        section3: {
            title: '3. 数据共享',
            content1:
                '我们不出售您的个人数据或图像内容。我们可能会与帮助我们运营扩展的第三方服务（例如 AWS）共享匿名的、汇总的数据。这些合作伙伴受严格的数据保护协议约束。',
        },
        section4: {
            title: '4. 您的权利',
            content1:
                '根据您所在的位置，您可能有权访问、更正或删除您的个人数据。要行使这些权利，请通过以下方式联系我们：service{\'@\'}weryai.com。',
        },
        section5: {
            title: '5. 变更',
            content1: '我们可能会更新此政策。变更后继续使用扩展程序即表示接受。',
        },
    },
    ja: {
        title: '「PromptReveal for WeryAI」ブラウザ拡張機能のプライバシーポリシー',
        section1: {
            title: '1. 収集するデータ',
            content1:
                '画像データ：「リバースプロンプト」機能を使用すると、右クリックした画像が、記述的なテキストプロンプトを生成する目的のみで、当社の安全なサーバーに一時的にアップロードされます。これらの画像は当社のサーバーに永続的に保存されることはありません。',
            content2:
                '技術および利用データ：問題の診断や拡張機能の改善に役立てるため、ブラウザのバージョン、拡張機能のバージョン、基本的な利用イベント（例：使用された機能）などの匿名情報を収集する場合があります。このデータは、お客様の身元とは結び付けられません。',
        },
        section2: {
            title: '2. データの利用方法',
            content1:
                '画像を分析し、AIが生成したプロンプトを返すというコア機能を提供するため。',
            content2: 'AIモデルの精度とパフォーマンスを向上させるため。',
            content3: '必要なトラブルシューティングおよびセキュリティ目的のため。',
        },
        section3: {
            title: '3. データの共有',
            content1:
                '当社は、お客様の個人データや画像コンテンツを販売することはありません。拡張機能の運営を支援するサードパーティサービス（例：AWS）と、匿名化された集計データを共有する場合があります。これらのパートナーは、厳格なデータ保護契約に拘束されます。',
        },
        section4: {
            title: '4. お客様の権利',
            content1:
                'お住まいの地域によっては、個人データへのアクセス、訂正、または削除の権利を有する場合があります。これらの権利を行使するには、service{\'@\'}weryai.com までご連絡ください。',
        },
        section5: {
            title: '5. 変更',
            content1:
                '当社はこのポリシーを更新する場合があります。変更後に拡張機能の利用を継続することは、承諾したものとみなされます。',
        },
    },
    ko: {
        title: '“PromptReveal for WeryAI” 브라우저 확장 프로그램 개인정보 처리방침',
        section1: {
            title: '1. 수집하는 데이터',
            content1:
                '이미지 데이터: “역 프롬프트” 기능을 사용할 때 마우스 오른쪽 버튼으로 클릭한 이미지는 설명 텍스트 프롬프트를 생성하기 위한 목적으로만 당사의 보안 서버에 일시적으로 업로드됩니다. 당사는 이러한 이미지를 서버에 영구적으로 저장하지 않습니다.',
            content2:
                '기술 및 사용 데이터: 문제 진단 및 확장 프로그램 개선을 돕기 위해 브라우저 버전, 확장 프로그램 버전 및 기본 사용 이벤트(예: 사용된 기능)와 같은 익명 정보를 수집할 수 있습니다. 이 데이터는 귀하의 신원과 연결되지 않습니다.',
        },
        section2: {
            title: '2. 데이터 사용 방법',
            content1:
                '이미지를 분석하고 AI 생성 프롬프트를 반환하는 핵심 기능을 제공하기 위해.',
            content2: 'AI 모델의 정확성과 성능을 향상시키기 위해.',
            content3: '필요한 문제 해결 및 보안 목적을 위해.',
        },
        section3: {
            title: '3. 데이터 공유',
            content1:
                '당사는 귀하의 개인 데이터나 이미지 콘텐츠를 판매하지 않습니다. 확장 프로그램 운영을 돕는 제3자 서비스(예: AWS)와 익명화된 집계 데이터를 공유할 수 있습니다. 이러한 파트너는 엄격한 데이터 보호 계약을 준수해야 합니다.',
        },
        section4: {
            title: '4. 귀하의 권리',
            content1:
                '거주 지역에 따라 귀하는 개인 데이터에 액세스, 수정 또는 삭제할 권리가 있을 수 있습니다. 이러한 권리를 행사하려면 service{\'@\'}weryai.com으로 문의하십시오.',
        },
        section5: {
            title: '5. 변경',
            content1:
                '당사는 이 방침을 업데이트할 수 있습니다. 변경 후에도 확장 프로그램을 계속 사용하면 수락한 것으로 간주됩니다.',
        },
    },
    es: {
        title: 'Política de Privacidad para la Extensión de Navegador “PromptReveal for WeryAI”',
        section1: {
            title: '1. Datos que Recopilamos',
            content1:
                'Datos de Imagen: Cuando utiliza la función “Reverse Prompt”, la imagen en la que hace clic derecho se carga temporalmente en nuestro servidor seguro únicamente con el fin de generar una instrucción de texto descriptiva. No almacenamos estas imágenes de forma permanente en nuestros servidores.',
            content2:
                'Datos Técnicos y de Uso: Podemos recopilar información anónima como la versión de su navegador, la versión de la extensión y eventos de uso básicos (por ejemplo, función utilizada) para ayudarnos a diagnosticar problemas y mejorar la extensión. Estos datos no están vinculados a su identidad.',
        },
        section2: {
            title: '2. Cómo Utilizamos sus Datos',
            content1:
                'Para proporcionar la funcionalidad principal de analizar imágenes y devolver instrucciones generadas por IA.',
            content2: 'Para mejorar la precisión y el rendimiento de nuestros modelos de IA.',
            content3: 'Para fines necesarios de solución de problemas y seguridad.',
        },
        section3: {
            title: '3. Intercambio de Datos',
            content1:
                'No vendemos sus datos personales ni el contenido de sus imágenes. Podemos compartir datos anónimos y agregados con servicios de terceros (por ejemplo, AWS) que nos ayudan a operar la extensión. Estos socios están sujetos a estrictos acuerdos de protección de datos.',
        },
        section4: {
            title: '4. Sus Derechos',
            content1:
                'Dependiendo de su ubicación, puede tener derechos para acceder, corregir o eliminar sus datos personales. Para ejercer estos derechos, contáctenos en: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Cambios',
            content1:
                'Podemos actualizar esta política. El uso continuado de la extensión después de los cambios constituye la aceptación.',
        },
    },
    fr: {
        title: 'Politique de Confidentialité pour l’Extension de Navigateur “PromptReveal for WeryAI”',
        section1: {
            title: '1. Données que Nous Collectons',
            content1:
                'Données d’Image : Lorsque vous utilisez la fonction “Reverse Prompt”, l’image sur laquelle vous faites un clic droit est temporairement téléchargée sur notre serveur sécurisé uniquement dans le but de générer une invite textuelle descriptive. Nous ne stockons pas ces images de manière permanente sur nos serveurs.',
            content2:
                'Données Techniques et d’Utilisation : Nous pouvons collecter des informations anonymes telles que la version de votre navigateur, la version de l’extension et les événements d’utilisation de base (par exemple, la fonction utilisée) pour nous aider à diagnostiquer les problèmes et à améliorer l’extension. Ces données ne sont pas liées à votre identité.',
        },
        section2: {
            title: '2. Comment Nous Utilisons Vos Données',
            content1:
                'Pour fournir la fonctionnalité de base consistant à analyser les images et à renvoyer des invites générées par l’IA.',
            content2: 'Pour améliorer la précision et les performances de nos modèles d’IA.',
            content3: 'À des fins de dépannage et de sécurité nécessaires.',
        },
        section3: {
            title: '3. Partage des Données',
            content1:
                'Nous ne vendons pas vos données personnelles ni le contenu de vos images. Nous pouvons partager des données anonymisées et agrégées avec des services tiers (par exemple, AWS) qui nous aident à exploiter l’extension. Ces partenaires sont liés par des accords stricts de protection des données.',
        },
        section4: {
            title: '4. Vos Droits',
            content1:
                'Selon votre emplacement, vous pouvez avoir des droits d’accès, de rectification ou de suppression de vos données personnelles. Pour exercer ces droits, contactez-nous à l’adresse : service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Changements',
            content1:
                'Nous pouvons mettre à jour cette politique. L’utilisation continue de l’extension après les modifications constitue une acceptation.',
        },
    },
    de: {
        title: 'Datenschutzerklärung für die Browser-Erweiterung „PromptReveal for WeryAI“',
        section1: {
            title: '1. Von uns erhobene Daten',
            content1:
                'Bilddaten: Wenn Sie die Funktion „Reverse Prompt“ verwenden, wird das Bild, auf das Sie rechtsklicken, vorübergehend auf unseren sicheren Server hochgeladen, ausschließlich zum Zweck der Erstellung eines beschreibenden Text-Prompts. Wir speichern diese Bilder nicht dauerhaft auf unseren Servern.',
            content2:
                'Technische und Nutzungsdaten: Wir können anonyme Informationen wie Ihre Browserversion, die Version der Erweiterung und grundlegende Nutzungsereignisse (z. B. verwendete Funktionen) sammeln, um uns bei der Diagnose von Problemen zu helfen und die Erweiterung zu verbessern. Diese Daten sind nicht mit Ihrer Identität verknüpft.',
        },
        section2: {
            title: '2. Wie wir Ihre Daten verwenden',
            content1:
                'Bereitstellung der Kernfunktionalität der Analyse von Bildern und Rückgabe von KI-generierten Prompts.',
            content2: 'Verbesserung der Genauigkeit und Leistung unserer KI-Modelle.',
            content3: 'Für notwendige Fehlerbehebungs- und Sicherheitszwecke.',
        },
        section3: {
            title: '3. Datenweitergabe',
            content1:
                'Wir verkaufen Ihre personenbezogenen Daten oder Bildinhalte nicht. Wir können anonymisierte, aggregierte Daten an Drittanbieter (z. B. AWS) weitergeben, die uns beim Betrieb der Erweiterung unterstützen. Diese Partner sind an strenge Datenschutzvereinbarungen gebunden.',
        },
        section4: {
            title: '4. Ihre Rechte',
            content1:
                'Je nach Standort haben Sie möglicherweise das Recht auf Auskunft, Berichtigung oder Löschung Ihrer personenbezogenen Daten. Um diese Rechte auszuüben, kontaktieren Sie uns unter: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Änderungen',
            content1:
                'Wir können diese Richtlinie aktualisieren. Die fortgesetzte Nutzung der Erweiterung nach Änderungen stellt eine Annahme dar.',
        },
    },
    ru: {
        title: 'Политика конфиденциальности расширения для браузера «PromptReveal for WeryAI»',
        section1: {
            title: '1. Данные, которые мы собираем',
            content1:
                'Данные изображений: когда вы используете функцию «Reverse Prompt», изображение, по которому вы щелкаете правой кнопкой мыши, временно загружается на наш защищенный сервер исключительно для создания описательной текстовой подсказки. Мы не храним эти изображения постоянно на наших серверах.',
            content2:
                'Технические данные и данные об использовании: мы можем собирать анонимную информацию, такую как версия вашего браузера, версия расширения и основные события использования (например, используемая функция), чтобы помочь нам диагностировать проблемы и улучшить расширение. Эти данные не связаны с вашей личностью.',
        },
        section2: {
            title: '2. Как мы используем ваши данные',
            content1:
                'Для обеспечения основной функциональности анализа изображений и возврата подсказок, созданных ИИ.',
            content2: 'Для повышения точности и производительности наших моделей ИИ.',
            content3: 'Для необходимых целей устранения неполадок и безопасности.',
        },
        section3: {
            title: '3. Передача данных',
            content1:
                'Мы не продаем ваши личные данные или содержимое изображений. Мы можем передавать анонимизированные, агрегированные данные сторонним сервисам (например, AWS), которые помогают нам управлять расширением. Эти партнеры связаны строгими соглашениями о защите данных.',
        },
        section4: {
            title: '4. Ваши права',
            content1:
                'В зависимости от вашего местоположения у вас могут быть права на доступ к вашим личным данным, их исправление или удаление. Чтобы воспользоваться этими правами, свяжитесь с нами по адресу: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Изменения',
            content1:
                'Мы можем обновлять эту политику. Дальнейшее использование расширения после внесения изменений означает их принятие.',
        },
    },
    pt: {
        title: 'Política de Privacidade para a Extensão de Navegador “PromptReveal for WeryAI”',
        section1: {
            title: '1. Dados que Coletamos',
            content1:
                'Dados de Imagem: Quando você usa o recurso “Reverse Prompt”, a imagem na qual você clica com o botão direito é carregada temporariamente em nosso servidor seguro exclusivamente com a finalidade de gerar um comando de texto descritivo. Não armazenamos essas imagens permanentemente em nossos servidores.',
            content2:
                'Dados Técnicos e de Uso: Podemos coletar informações anônimas, como a versão do seu navegador, a versão da extensão e eventos básicos de uso (por exemplo, recurso usado), para nos ajudar a diagnosticar problemas e melhorar a extensão. Esses dados não estão vinculados à sua identidade.',
        },
        section2: {
            title: '2. Como Usamos Seus Dados',
            content1:
                'Para fornecer a funcionalidade principal de analisar imagens e retornar comandos gerados por IA.',
            content2: 'Para melhorar a precisão e o desempenho de nossos modelos de IA.',
            content3: 'Para fins de segurança e solução de problemas necessários.',
        },
        section3: {
            title: '3. Compartilhamento de Dados',
            content1:
                'Não vendemos seus dados pessoais ou conteúdo de imagem. Podemos compartilhar dados anônimos e agregados com serviços de terceiros (por exemplo, AWS) que nos ajudam a operar a extensão. Esses parceiros estão vinculados a acordos rígidos de proteção de dados.',
        },
        section4: {
            title: '4. Seus Direitos',
            content1:
                'Dependendo da sua localização, você pode ter direitos de acessar, corrigir ou excluir seus dados pessoais. Para exercer esses direitos, entre em contato conosco em: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Alterações',
            content1:
                'Podemos atualizar esta política. O uso continuado da extensão após as alterações constitui aceitação.',
        },
    },
    it: {
        title: 'Informativa sulla Privacy per l’estensione del browser “PromptReveal for WeryAI”',
        section1: {
            title: '1. Dati che raccogliamo',
            content1:
                'Dati dell’immagine: quando utilizzi la funzione “Reverse Prompt”, l’immagine su cui fai clic con il tasto destro viene temporaneamente caricata sul nostro server sicuro esclusivamente al fine di generare un prompt di testo descrittivo. Non memorizziamo queste immagini in modo permanente sui nostri server.',
            content2:
                'Dati tecnici e di utilizzo: potremmo raccogliere informazioni anonime come la versione del browser, la versione dell’estensione e gli eventi di utilizzo di base (ad esempio, la funzione utilizzata) per aiutarci a diagnosticare i problemi e migliorare l’estensione. Questi dati non sono collegati alla tua identità.',
        },
        section2: {
            title: '2. Come utilizziamo i tuoi dati',
            content1:
                'Per fornire la funzionalità principale di analisi delle immagini e restituzione di prompt generati dall’IA.',
            content2: 'Per migliorare la precisione e le prestazioni dei nostri modelli di IA.',
            content3: 'Per scopi necessari di risoluzione dei problemi e sicurezza.',
        },
        section3: {
            title: '3. Condivisione dei dati',
            content1:
                'Non vendiamo i tuoi dati personali o i contenuti delle immagini. Potremmo condividere dati anonimi e aggregati con servizi di terze parti (ad esempio, AWS) che ci aiutano a gestire l’estensione. Questi partner sono vincolati da rigorosi accordi sulla protezione dei dati.',
        },
        section4: {
            title: '4. I tuoi diritti',
            content1:
                'A seconda della tua posizione, potresti avere il diritto di accedere, correggere o eliminare i tuoi dati personali. Per esercitare questi diritti, contattaci all’indirizzo: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Modifiche',
            content1:
                'Potremmo aggiornare questa informativa. L’uso continuato dell’estensione dopo le modifiche costituisce l’accettazione delle stesse.',
        },
    },
    ar: {
        title: 'سياسة الخصوصية لملحق المتصفح "PromptReveal for WeryAI"',
        section1: {
            title: '1. البيانات التي نجمعها',
            content1:
                'بيانات الصور: عند استخدام ميزة "المطالبة العكسية"، يتم تحميل الصورة التي تنقر عليها بزر الماوس الأيمن مؤقتًا على خادمنا الآمن لغرض وحيد وهو إنشاء مطالبة نصية وصفية. نحن لا نخزن هذه الصور بشكل دائم على خوادمنا.',
            content2:
                'البيانات الفنية وبيانات الاستخدام: قد نجمع معلومات مجهولة المصدر مثل إصدار متصفحك وإصدار الملحق وأحداث الاستخدام الأساسية (مثل الميزة المستخدمة) لمساعدتنا في تشخيص المشكلات وتحسين الملحق. هذه البيانات غير مرتبطة بهويتك.',
        },
        section2: {
            title: '2. كيف نستخدم بياناتك',
            content1: 'لتوفير الوظيفة الأساسية لتحليل الصور وإرجاع المطالبات التي تم إنشاؤها بواسطة الذكاء الاصطناعي.',
            content2: 'لتحسين دقة وأداء نماذج الذكاء الاصطناعي لدينا.',
            content3: 'لأغراض استكشاف الأخطاء وإصلاحها والأمن الضرورية.',
        },
        section3: {
            title: '3. مشاركة البيانات',
            content1:
                'نحن لا نبيع بياناتك الشخصية أو محتوى صورك. قد نشارك بيانات مجهولة المصدر ومجمعة مع خدمات خارجية (مثل AWS) التي تساعدنا في تشغيل الملحق. هؤلاء الشركاء ملزمون باتفاقيات صارمة لحماية البيانات.',
        },
        section4: {
            title: '4. حقوقك',
            content1:
                'اعتمادًا على موقعك، قد يكون لك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها. لممارسة هذه الحقوق، اتصل بنا على: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. التغييرات',
            content1: 'قد نقوم بتحديث هذه السياسة. استمرار استخدام الملحق بعد التغييرات يعتبر قبولاً لها.',
        },
    },
    tw: {
        title: 'WeryAI「PromptReveal」瀏覽器擴充功能隱私政策',
        section1: {
            title: '1. 我們收集的資料',
            content1:
                '圖片資料：當您使用「反向提示」功能時，您右鍵點選的圖片會暫時上傳到我們的安全伺服器，僅用於生成描述性文字提示。我們不會在伺服器上永久保存這些圖片。',
            content2:
                '技術與使用資料：我們可能會收集匿名資訊，例如您的瀏覽器版本、擴充功能版本與基本使用事件（例如使用了哪個功能），以協助診斷問題並改進擴充功能。這些資料不會與您的身份連結。',
        },
        section2: {
            title: '2. 我們如何使用您的資料',
            content1:
                '用於提供分析圖片並回傳 AI 生成提示的核心功能。',
            content2: '用於提升我們 AI 模型的準確度與效能。',
            content3: '用於必要的疑難排解與安全目的。',
        },
        section3: {
            title: '3. 資料分享',
            content1:
                '我們不會出售您的個人資料或圖片內容。我們可能會與協助我們營運擴充功能的第三方服務（例如 AWS）分享匿名、彙總資料。這些合作夥伴受嚴格的資料保護協議約束。',
        },
        section4: {
            title: '4. 您的權利',
            content1:
                '依據您的所在地，您可能擁有存取、更正或刪除個人資料的權利。如欲行使這些權利，請聯繫：service{\'@\'}weryai.com。',
        },
        section5: {
            title: '5. 變更',
            content1:
                '我們可能會更新本政策。更新後持續使用擴充功能即視為同意。',
        },
    },
    pl: {
        title: 'Polityka prywatności rozszerzenia przeglądarki „PromptReveal for WeryAI”',
        section1: {
            title: '1. Dane, które zbieramy',
            content1:
                'Dane obrazu: Gdy korzystasz z funkcji „Reverse Prompt”, obraz kliknięty prawym przyciskiem myszy jest tymczasowo przesyłany na nasz bezpieczny serwer wyłącznie w celu wygenerowania opisowego promptu tekstowego. Nie przechowujemy tych obrazów trwale na naszych serwerach.',
            content2:
                'Dane techniczne i o użytkowaniu: Możemy zbierać anonimowe informacje, takie jak wersja przeglądarki, wersja rozszerzenia oraz podstawowe zdarzenia użycia (np. użyta funkcja), aby diagnozować problemy i ulepszać rozszerzenie. Dane te nie są powiązane z Twoją tożsamością.',
        },
        section2: {
            title: '2. Jak wykorzystujemy Twoje dane',
            content1:
                'Aby zapewnić podstawową funkcjonalność analizy obrazów i zwracania promptów generowanych przez AI.',
            content2: 'Aby poprawić dokładność i wydajność naszych modeli AI.',
            content3: 'W niezbędnych celach rozwiązywania problemów i bezpieczeństwa.',
        },
        section3: {
            title: '3. Udostępnianie danych',
            content1:
                'Nie sprzedajemy Twoich danych osobowych ani treści obrazów. Możemy udostępniać zanonimizowane, zagregowane dane usługom stron trzecich (np. AWS), które pomagają nam obsługiwać rozszerzenie. Partnerzy ci są związani rygorystycznymi umowami o ochronie danych.',
        },
        section4: {
            title: '4. Twoje prawa',
            content1:
                'W zależności od Twojej lokalizacji możesz mieć prawo dostępu, sprostowania lub usunięcia swoich danych osobowych. Aby skorzystać z tych praw, skontaktuj się z nami: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Zmiany',
            content1:
                'Możemy aktualizować tę politykę. Dalsze korzystanie z rozszerzenia po zmianach oznacza akceptację.',
        },
    },
    th: {
        title: 'นโยบายความเป็นส่วนตัวของส่วนขยายเบราว์เซอร์ “PromptReveal for WeryAI”',
        section1: {
            title: '1. ข้อมูลที่เราเก็บรวบรวม',
            content1:
                'ข้อมูลภาพ: เมื่อคุณใช้ฟีเจอร์ “Reverse Prompt” รูปภาพที่คุณคลิกขวาจะถูกอัปโหลดชั่วคราวไปยังเซิร์ฟเวอร์ที่ปลอดภัยของเราเพื่อจุดประสงค์เดียวคือสร้างพรอมต์ข้อความเชิงบรรยาย เราไม่เก็บรูปภาพเหล่านี้ไว้ถาวรบนเซิร์ฟเวอร์ของเรา。',
            content2:
                'ข้อมูลทางเทคนิคและการใช้งาน: เราอาจเก็บข้อมูลแบบไม่ระบุตัวตน เช่น เวอร์ชันเบราว์เซอร์ เวอร์ชันส่วนขยาย และเหตุการณ์การใช้งานพื้นฐาน (เช่น ฟีเจอร์ที่ใช้) เพื่อช่วยวิเคราะห์ปัญหาและปรับปรุงส่วนขยาย ข้อมูลเหล่านี้ไม่เชื่อมโยงกับตัวตนของคุณ。',
        },
        section2: {
            title: '2. เราใช้ข้อมูลของคุณอย่างไร',
            content1:
                'เพื่อให้บริการฟังก์ชันหลักในการวิเคราะห์รูปภาพและส่งคืนพรอมต์ที่สร้างโดย AI',
            content2: 'เพื่อปรับปรุงความแม่นยำและประสิทธิภาพของโมเดล AI ของเรา',
            content3: 'เพื่อวัตถุประสงค์ด้านการแก้ไขปัญหาและความปลอดภัยที่จำเป็น',
        },
        section3: {
            title: '3. การแชร์ข้อมูล',
            content1:
                'เราไม่ขายข้อมูลส่วนบุคคลหรือเนื้อหาภาพของคุณ เราอาจแชร์ข้อมูลแบบไม่ระบุตัวตนและแบบสรุปรวมกับบริการของบุคคลที่สาม (เช่น AWS) ที่ช่วยให้เราดำเนินการส่วนขยาย คู่ค้าเหล่านี้อยู่ภายใต้ข้อตกลงการคุ้มครองข้อมูลที่เข้มงวด',
        },
        section4: {
            title: '4. สิทธิของคุณ',
            content1:
                'ขึ้นอยู่กับตำแหน่งที่คุณอยู่ คุณอาจมีสิทธิ์เข้าถึง แก้ไข หรือ ลบข้อมูลส่วนบุคคลของคุณ หากต้องการใช้สิทธิเหล่านี้ โปรดติดต่อเราที่: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. การเปลี่ยนแปลง',
            content1:
                'เราอาจอัปเดตนโยบายนี้ การใช้ส่วนขยายต่อหลังจากมีการเปลี่ยนแปลงถือว่าเป็นการยอมรับ',
        },
    },
    da: {
        title: 'Privatlivspolitik for browserudvidelsen “PromptReveal for WeryAI”',
        section1: {
            title: '1. Data vi indsamler',
            content1:
                'Billeddata: Når du bruger funktionen “Reverse Prompt”, uploades det billede, du højreklikker på, midlertidigt til vores sikre server udelukkende med det formål at generere en beskrivende tekstprompt. Vi gemmer ikke disse billeder permanent på vores servere.',
            content2:
                'Tekniske- og brugsdata: Vi kan indsamle anonyme oplysninger såsom din browserversion, udvidelsesversion og grundlæggende brugshændelser (f.eks. brugt funktion) for at hjælpe med fejlfinding og forbedre udvidelsen. Disse data er ikke knyttet til din identitet.',
        },
        section2: {
            title: '2. Sådan bruger vi dine data',
            content1:
                'For at levere kernefunktionaliteten til billedanalyse og returnere AI-genererede prompts.',
            content2: 'For at forbedre nøjagtigheden og ydeevnen af vores AI-modeller.',
            content3: 'Til nødvendige fejlfinding- og sikkerhedsformål.',
        },
        section3: {
            title: '3. Datadeling',
            content1:
                'Vi sælger ikke dine personlige data eller billedindhold. Vi kan dele anonymiserede, aggregerede data med tredjepartstjenester (f.eks. AWS), der hjælper os med at drive udvidelsen. Disse partnere er bundet af strenge databeskyttelsesaftaler.',
        },
        section4: {
            title: '4. Dine rettigheder',
            content1:
                'Afhængigt af din placering kan du have ret til at få adgang til, rette eller slette dine personlige data. For at udøve disse rettigheder kan du kontakte os på: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Ændringer',
            content1:
                'Vi kan opdatere denne politik. Fortsat brug af udvidelsen efter ændringer udgør accept.',
        },
    },
    no: {
        title: 'Personvernerklæring for nettleserutvidelsen “PromptReveal for WeryAI”',
        section1: {
            title: '1. Data vi samler inn',
            content1:
                'Bildedata: Når du bruker funksjonen “Reverse Prompt”, lastes bildet du høyreklikker på midlertidig opp til vår sikre server kun for å generere en beskrivende tekstprompt. Vi lagrer ikke disse bildene permanent på serverne våre.',
            content2:
                'Tekniske og bruksdata: Vi kan samle inn anonym informasjon som nettleserversjon, utvidelsesversjon og grunnleggende brukshendelser (f.eks. brukt funksjon) for å hjelpe oss med feilsøking og forbedring av utvidelsen. Disse dataene er ikke knyttet til identiteten din.',
        },
        section2: {
            title: '2. Slik bruker vi dataene dine',
            content1:
                'For å levere kjernefunksjonaliteten for bildeanalyse og returnere AI-genererte prompt.',
            content2: 'For å forbedre nøyaktigheten og ytelsen til AI-modellene våre.',
            content3: 'For nødvendige formål knyttet til feilsøking og sikkerhet.',
        },
        section3: {
            title: '3. Datadeling',
            content1:
                'Vi selger ikke personopplysningene dine eller bildeinnholdet. Vi kan dele anonymiserte, aggregerte data med tredjepartstjenester (f.eks. AWS) som hjelper oss med å drifte utvidelsen. Disse partnerne er bundet av strenge databeskyttelsesavtaler.',
        },
        section4: {
            title: '4. Dine rettigheter',
            content1:
                'Avhengig av hvor du befinner deg, kan du ha rett til å få tilgang til, rette eller slette personopplysningene dine. For å utøve disse rettighetene, kontakt oss på: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Endringer',
            content1:
                'Vi kan oppdatere denne policyen. Fortsatt bruk av utvidelsen etter endringer innebærer aksept.',
        },
    },
    nl: {
        title: 'Privacybeleid voor de browserextensie “PromptReveal for WeryAI”',
        section1: {
            title: '1. Gegevens die we verzamelen',
            content1:
                'Beeldgegevens: wanneer je de functie “Reverse Prompt” gebruikt, wordt de afbeelding waarop je rechtsklikt tijdelijk geüpload naar onze beveiligde server uitsluitend om een beschrijvende tekstprompt te genereren. We slaan deze afbeeldingen niet permanent op onze servers op.',
            content2:
                'Technische en gebruiksgegevens: we kunnen anonieme informatie verzamelen, zoals je browserversie, extensieversie en basisgebeurtenissen (bijv. gebruikte functie) om problemen te diagnosticeren en de extensie te verbeteren. Deze gegevens zijn niet aan jouw identiteit gekoppeld.',
        },
        section2: {
            title: '2. Hoe we je gegevens gebruiken',
            content1:
                'Om de kernfunctionaliteit te bieden van beeldanalyse en het teruggeven van door AI gegenereerde prompts.',
            content2: 'Om de nauwkeurigheid en prestaties van onze AI-modellen te verbeteren.',
            content3: 'Voor noodzakelijke doeleinden van probleemoplossing en beveiliging.',
        },
        section3: {
            title: '3. Gegevensdeling',
            content1:
                'We verkopen je persoonlijke gegevens of beeldinhoud niet. We kunnen geanonimiseerde, geaggregeerde gegevens delen met diensten van derden (bijv. AWS) die ons helpen de extensie te beheren. Deze partners zijn gebonden aan strikte gegevensbeschermingsovereenkomsten.',
        },
        section4: {
            title: '4. Jouw rechten',
            content1:
                'Afhankelijk van je locatie kun je het recht hebben om je persoonsgegevens in te zien, te corrigeren of te verwijderen. Om deze rechten uit te oefenen, neem contact met ons op via: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Wijzigingen',
            content1:
                'We kunnen dit beleid bijwerken. Voortgezet gebruik van de extensie na wijzigingen houdt acceptatie in.',
        },
    },
    id: {
        title: 'Kebijakan Privasi untuk Ekstensi Peramban “PromptReveal for WeryAI”',
        section1: {
            title: '1. Data yang kami kumpulkan',
            content1:
                'Data gambar: Saat Anda menggunakan fitur “Reverse Prompt”, gambar yang Anda klik kanan akan diunggah sementara ke server aman kami semata-mata untuk menghasilkan prompt teks deskriptif. Kami tidak menyimpan gambar ini secara permanen di server kami.',
            content2:
                'Data teknis & penggunaan: Kami dapat mengumpulkan informasi anonim seperti versi peramban, versi ekstensi, dan peristiwa penggunaan dasar (mis. fitur yang digunakan) untuk membantu mendiagnosis masalah dan meningkatkan ekstensi. Data ini tidak terhubung dengan identitas Anda.',
        },
        section2: {
            title: '2. Bagaimana kami menggunakan data Anda',
            content1:
                'Untuk menyediakan fungsi inti analisis gambar dan mengembalikan prompt yang dihasilkan AI.',
            content2: 'Untuk meningkatkan akurasi dan kinerja model AI kami.',
            content3: 'Untuk tujuan pemecahan masalah dan keamanan yang diperlukan.',
        },
        section3: {
            title: '3. Berbagi data',
            content1:
                'Kami tidak menjual data pribadi atau konten gambar Anda. Kami dapat membagikan data anonim dan agregat kepada layanan pihak ketiga (mis. AWS) yang membantu kami mengoperasikan ekstensi. Mitra ini terikat oleh perjanjian perlindungan data yang ketat.',
        },
        section4: {
            title: '4. Hak Anda',
            content1:
                'Bergantung pada lokasi Anda, Anda mungkin memiliki hak untuk mengakses, memperbaiki, atau menghapus data pribadi Anda. Untuk menggunakan hak-hak ini, hubungi kami di: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Perubahan',
            content1:
                'Kami dapat memperbarui kebijakan ini. Penggunaan ekstensi secara berkelanjutan setelah perubahan dianggap sebagai persetujuan.',
        },
    },
    tr: {
        title: '“PromptReveal for WeryAI” Tarayıcı Eklentisi Gizlilik Politikası',
        section1: {
            title: '1. Topladığımız Veriler',
            content1:
                'Görsel verileri: “Reverse Prompt” özelliğini kullandığınızda, sağ tıkladığınız görsel yalnızca açıklayıcı bir metin istemi oluşturmak amacıyla geçici olarak güvenli sunucumuza yüklenir. Bu görselleri sunucularımızda kalıcı olarak saklamıyoruz.',
            content2:
                'Teknik ve kullanım verileri: Tarayıcı sürümünüz, eklenti sürümünüz ve temel kullanım olayları (örn. kullanılan özellik) gibi anonim bilgileri, sorunları teşhis etmemize ve eklentiyi iyileştirmemize yardımcı olmak için toplayabiliriz. Bu veriler kimliğinizle ilişkilendirilmez.',
        },
        section2: {
            title: '2. Verilerinizi Nasıl Kullanıyoruz',
            content1:
                'Görüntüleri analiz edip AI tarafından oluşturulan istemleri döndürmeye yönelik temel işlevi sağlamak için.',
            content2: 'AI modellerimizin doğruluğunu ve performansını artırmak için.',
            content3: 'Gerekli sorun giderme ve güvenlik amaçları için.',
        },
        section3: {
            title: '3. Veri Paylaşımı',
            content1:
                'Kişisel verilerinizi veya görsel içeriklerinizi satmayız. Eklentiyi işletmemize yardımcı olan üçüncü taraf hizmetlerle (ör. AWS) anonimleştirilmiş, toplulaştırılmış verileri paylaşabiliriz. Bu ortaklar sıkı veri koruma anlaşmalarıyla bağlıdır.',
        },
        section4: {
            title: '4. Haklarınız',
            content1:
                'Bulunduğunuz konuma bağlı olarak kişisel verilerinize erişme, düzeltme veya silme hakkına sahip olabilirsiniz. Bu hakları kullanmak için bizimle şu adresten iletişime geçin: service{\'@\'}weryai.com.',
        },
        section5: {
            title: '5. Değişiklikler',
            content1:
                'Bu politikayı güncelleyebiliriz. Değişikliklerden sonra eklentiyi kullanmaya devam etmeniz kabul anlamına gelir.',
        },
    },
}

